import messages from '../lang/preferences';
export const slides = [
    {
        step: 1,
        type: 'pageStart',
        title: messages.TITRE,
        accueils: {
            accueil1: messages.ACCUEIL5_INFO1,
            accueil2: messages.ACCUEIL5_INFO2,
            accueil3: messages.ACCUEIL5_INFO3,
            accueil8: messages.ACCUEIL5_INFO8,
            accueil18: messages.ACCUEIL5_INFO8, // Ensure orange warning text appears
        },
    },

    //supposition
    {
        step: 2,
        type: 'informations',
        titre: messages.TITRE,
        titre1: messages.TITRE1,
        contenu: messages.INFO2,
        titre2: messages.TITRE2,
        consignes: [
            {
                consigne: messages.INFOINST2bis,
            },
        ]
    },

    {
        step: 3,
        inputNumber: 0,
        type: 'pageCheckBox',
        pageTitleType: messages.SUPPOSITIONTITRE,
        pageTitleInfos: [
            {
                info: messages.SUPPOSITIONINFO2,
            },
        ],
        aide: messages.AIDECHECKBOX,
        inputsCB: [
            {
                labelCB: messages.SUPPOSITIONQUESTION5,
                value: false,
                key: 'SUPPOSITIONQUESTION5',
            },
            {
                labelCB: messages.SUPPOSITIONQUESTION6,
                value: false,
                key: 'SUPPOSITIONQUESTION6',
            },
            {
                labelCB: messages.SUPPOSITIONQUESTION7,
                value: false,
                key: 'SUPPOSITIONQUESTION7',
            },
            {
                labelCB: messages.SUPPOSITIONQUESTION8,
                value: false,
                key: 'SUPPOSITIONQUESTION8',
            },
        ],
    },

    {
        step: 4,
        inputNumber: 1,
        type: 'pageCheckBox',
        pageTitleType: messages.SUPPOSITIONTITRE,
        pageTitleInfos: [
            {
                info: messages.SUPPOSITIONINFO3,
            },
        ],
        aide: messages.AIDECHECKBOX,
        inputsCB: [
            {
                labelCB: messages.SUPPOSITIONQUESTION9,
                value: false,
                key: 'SUPPOSITIONQUESTION9',
            },
            {
                labelCB: messages.SUPPOSITIONQUESTION10,
                value: false,
                key: 'SUPPOSITIONQUESTION10',
            },
            {
                labelCB: messages.SUPPOSITIONQUESTION11,
                value: false,
                key: 'SUPPOSITIONQUESTION11',
            },
            {
                labelCB: messages.SUPPOSITIONQUESTION12,
                value: false,
                key: 'SUPPOSITIONQUESTION12',
            },
        ],
    },

    {
        step: 5,
        inputNumber: 2,
        type: 'pageCheckBox',
        pageTitleType: messages.SUPPOSITIONTITRE,
        pageTitleInfos: [
            {
                info: messages.SUPPOSITIONINFO4,
            },
        ],
        aide: messages.AIDECHECKBOX,
        inputsCB: [
            {
                labelCB: messages.SUPPOSITIONQUESTION13,
                value: false,
                key: 'SUPPOSITIONQUESTION13',
            },
            {
                labelCB: messages.SUPPOSITIONQUESTION14,
                value: false,
                key: 'SUPPOSITIONQUESTION14',
            },
            {
                labelCB: messages.SUPPOSITIONQUESTION15,
                value: false,
                key: 'SUPPOSITIONQUESTION15',
            },
            {
                labelCB: messages.SUPPOSITIONQUESTION16,
                value: false,
                key: 'SUPPOSITIONQUESTION16',
            },
        ],
    },

    //fin supposition

    // FAITS VS OPINIONS (18 slides) -- now steps 6-24
    {
        step: 6,
        type: 'informations',
        titre1: messages.FAITSOPINIONSTITLE,
        contenu: { id: 'app.faitsopinionsinstruction', defaultMessage: 'Il ne s’agit pas de dire si vous êtes d’accord ou non avec l’affirmation.\nVotre tâche consiste uniquement à décider si l’énoncé exprime principalement un fait vérifiable ou une opinion/jugement.' },
        consignes: []
    },
    ...[
        1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18
    ].map((num, idx) => ({
        step: 7 + idx,
        inputNumber: 102 + idx,
        type: 'pageRadioFO',
        pageTitleType: messages.FAITSOPINIONSTITLE,
        pageTitleInfos: [
            { info: messages['FAITSOPINIONSQUESTION' + num] }
        ],
        aide: messages.FAITSOPINIONSAID,
        inputsCB: [
            {
                labelCB: messages['FAITSOPINIONSQUESTION' + num],
                value: false,
                key: 'FAITSOPINIONSQUESTION' + num,
            }
        ],
        leftLabel: messages.FAITSOPINIONSFAIT,
        rightLabel: messages.FAITSOPINIONSOPINION,
    })),

    //traits personnalité (all steps shifted up by 19)
    {
        step: 25,
        type: 'informations',
        titre: messages.TITRE,
        titre1: messages.TITRE1,
        contenu: messages.INFO3,
        titre2: messages.TITRE2,
        consignes: [
            {
                consigne: messages.INFOINST3,
            },
        ]
    },

    {
        step: 26,
        inputNumber: 3,
        type: 'pageTraitsPersonnalite',
        stepRange: 25,
        leftTraitPersonnalite: messages.TRAITSPERSONNALITE1BIS,
        rightTraitPersonnalite: messages.TRAITSPERSONNALITE1,
        value: 0,
        key: 'TP1',
        labelDefault: messages.TRAITSPERSONNALITEDEFAULT,
        labelLvl: [
            {
                labelTP: messages.TRAITSPERSONNALITELVL1,
            },
            {
                labelTP: messages.TRAITSPERSONNALITELVL2,
            },
            {
                labelTP: messages.TRAITSPERSONNALITELVL3,
            },
            {
                labelTP: messages.TRAITSPERSONNALITELVL4,
            },
        ]
    },

    {
        step: 27,
        inputNumber: 4,
        type: 'pageTraitsPersonnalite',
        stepRange: 25,
        leftTraitPersonnalite: messages.TRAITSPERSONNALITE6BIS,
        rightTraitPersonnalite: messages.TRAITSPERSONNALITE6,
        value: 0,
        key: 'TP2',
        labelDefault: messages.TRAITSPERSONNALITEDEFAULT,
        labelLvl: [
            {
                labelTP: messages.TRAITSPERSONNALITELVL1,
            },
            {
                labelTP: messages.TRAITSPERSONNALITELVL2,
            },
            {
                labelTP: messages.TRAITSPERSONNALITELVL3,
            },
            {
                labelTP: messages.TRAITSPERSONNALITELVL4,
            },
        ]
    },
    {
        step: 28,
        inputNumber: 5,
        type: 'pageTraitsPersonnalite',
        stepRange: 25,
        leftTraitPersonnalite: messages.TRAITSPERSONNALITE8BIS,
        rightTraitPersonnalite: messages.TRAITSPERSONNALITE8,
        value: 0,
        key: 'TP3',
        labelDefault: messages.TRAITSPERSONNALITEDEFAULT,
        labelLvl: [
            {
                labelTP: messages.TRAITSPERSONNALITELVL1,
            },
            {
                labelTP: messages.TRAITSPERSONNALITELVL2,
            },
            {
                labelTP: messages.TRAITSPERSONNALITELVL3,
            },
            {
                labelTP: messages.TRAITSPERSONNALITELVL4,
            },
        ]
    },
    {
        step: 29,
        inputNumber: 6,
        type: 'pageTraitsPersonnalite',
        stepRange: 25,
        leftTraitPersonnalite: messages.TRAITSPERSONNALITE2BIS,
        rightTraitPersonnalite: messages.TRAITSPERSONNALITE2,
        value: 0,
        key: 'TP4',
        labelDefault: messages.TRAITSPERSONNALITEDEFAULT,
        labelLvl: [
            {
                labelTP: messages.TRAITSPERSONNALITELVL1,
            },
            {
                labelTP: messages.TRAITSPERSONNALITELVL2,
            },
            {
                labelTP: messages.TRAITSPERSONNALITELVL3,
            },
            {
                labelTP: messages.TRAITSPERSONNALITELVL4,
            },
        ]
    },
    {
        step: 30,
        inputNumber: 7,
        type: 'pageTraitsPersonnalite',
        stepRange: 25,
        leftTraitPersonnalite: messages.TRAITSPERSONNALITE4BIS,
        rightTraitPersonnalite: messages.TRAITSPERSONNALITE4,
        value: 0,
        key: 'TP5',
        labelDefault: messages.TRAITSPERSONNALITEDEFAULT,
        labelLvl: [
            {
                labelTP: messages.TRAITSPERSONNALITELVL1,
            },
            {
                labelTP: messages.TRAITSPERSONNALITELVL2,
            },
            {
                labelTP: messages.TRAITSPERSONNALITELVL3,
            },
            {
                labelTP: messages.TRAITSPERSONNALITELVL4,
            },
        ]
    },
    {
        step: 31,
        inputNumber: 8,
        type: 'pageTraitsPersonnalite',
        stepRange: 25,
        leftTraitPersonnalite: messages.TRAITSPERSONNALITE3BIS,
        rightTraitPersonnalite: messages.TRAITSPERSONNALITE3,
        value: 0,
        key: 'TP6',
        labelDefault: messages.TRAITSPERSONNALITEDEFAULT,
        labelLvl: [
            {
                labelTP: messages.TRAITSPERSONNALITELVL1,
            },
            {
                labelTP: messages.TRAITSPERSONNALITELVL2,
            },
            {
                labelTP: messages.TRAITSPERSONNALITELVL3,
            },
            {
                labelTP: messages.TRAITSPERSONNALITELVL4,
            },
        ]
    },

    {
        step: 32,
        inputNumber: 9,
        type: 'pageTraitsPersonnalite',
        stepRange: 25,
        leftTraitPersonnalite: messages.TRAITSPERSONNALITE5BIS,
        rightTraitPersonnalite: messages.TRAITSPERSONNALITE5,
        value: 0,
        key: 'TP7',
        labelDefault: messages.TRAITSPERSONNALITEDEFAULT,
        labelLvl: [
            {
                labelTP: messages.TRAITSPERSONNALITELVL1,
            },
            {
                labelTP: messages.TRAITSPERSONNALITELVL2,
            },
            {
                labelTP: messages.TRAITSPERSONNALITELVL3,
            },
            {
                labelTP: messages.TRAITSPERSONNALITELVL4,
            },
        ]
    },

    {
        step: 33,
        inputNumber: 10,
        type: 'pageTraitsPersonnalite',
        stepRange: 25,
        leftTraitPersonnalite: messages.TRAITSPERSONNALITE7BIS,
        rightTraitPersonnalite: messages.TRAITSPERSONNALITE7,
        value: 0,
        key: 'TP8',
        labelDefault: messages.TRAITSPERSONNALITEDEFAULT,
        labelLvl: [
            {
                labelTP: messages.TRAITSPERSONNALITELVL1,
            },
            {
                labelTP: messages.TRAITSPERSONNALITELVL2,
            },
            {
                labelTP: messages.TRAITSPERSONNALITELVL3,
            },
            {
                labelTP: messages.TRAITSPERSONNALITELVL4,
            },
        ]
    },
    //questions avec slides
    //fin traits personnalité



    //preferences professionnels
    {
        step: 34,
        type: 'informations',
        titre: messages.TITRE,
        titre1: messages.TITRE1,
        contenu: messages.INFO4,
        titre2: messages.TITRE2,
        consignes: [
            {
                consigne: messages.INFOINST4,
            },
        ]
    },

    {
        step: 35,
        inputNumber: 11,
        type: 'pageRadioButton',
        instructions: [
            {
                instruction: messages.PREFERENCESPRO1,
            },
        ],
        value: '',
        key: 'PREF1',
        inputs: [
            {
                label: messages.PREFERENCESPRO1REPONSE1,
                valueKey: 'PREF_LEADERSHIP',
            },
            {
                label: messages.PREFERENCESPRO1REPONSE2,
                valueKey: 'PREF_TASKVARIABILITY',
            },
        ]
    },

    {
        step: 36,
        inputNumber: 12,
        type: 'pageRadioButton',
        instructions: [
            {
                instruction: messages.PREFERENCESPRO1,
            },
        ],
        value: '',
        key: 'PREF2',
        inputs: [
            {
                label: messages.PREFERENCESPRO2REPONSE1,
                valueKey: 'PREF_INTELLECTUALSTIMULATION',
            },
            {
                label: messages.PREFERENCESPRO2REPONSE2,
                valueKey: 'PREF_SALARY',
            },
        ]
    },

    {
        step: 37,
        inputNumber: 13,
        type: 'pageRadioButton',
        instructions: [
            {
                instruction: messages.PREFERENCESPRO1,
            },
        ],

        value: '',
        key: 'PREF3',
        inputs: [
            {
                label: messages.PREFERENCESPRO3REPONSE1,
                valueKey: 'PREF_ENJOYWORK',
            },
            {
                label: messages.PREFERENCESPRO3REPONSE2,
                valueKey: 'PREF_SECURITY',
            },
        ]
    },

    {
        step: 38,
        inputNumber: 14,
        type: 'pageRadioButton',
        instructions: [
            {
                instruction: messages.PREFERENCESPRO1,
            },
        ],

        value: '',
        key: 'PREF4',
        inputs: [
            {
                label: messages.PREFERENCESPRO4REPONSE1,
                valueKey: 'PREF_SALARY',
            },
            {
                label: messages.PREFERENCESPRO4REPONSE2,
                valueKey: 'PREF_LEADERSHIP',
            },
        ]
    },

    {
        step: 39,
        inputNumber: 15,
        type: 'pageRadioButton',
        instructions: [
            {
                instruction: messages.PREFERENCESPRO1,
            },
        ],

        value: '',
        key: 'PREF5',
        inputs: [
            {
                label: messages.PREFERENCESPRO5REPONSE1,
                valueKey: 'PREF_INTELLECTUALSTIMULATION',
            },
            {
                label: messages.PREFERENCESPRO5REPONSE2,
                valueKey: 'PREF_SECURITY',
            },
        ]
    },

    {
        step: 40,
        inputNumber: 16,
        type: 'pageRadioButton',
        instructions: [
            {
                instruction: messages.PREFERENCESPRO1,
            },
        ],

        value: '',
        key: 'PREF6',
        inputs: [
            {
                label: messages.PREFERENCESPRO6REPONSE1,
                valueKey: 'PREF_TASKVARIABILITY',
            },
            {
                label: messages.PREFERENCESPRO6REPONSE2,
                valueKey: 'PREF_ENJOYWORK',
            },
        ]
    },

    {
        step: 41,
        inputNumber: 17,
        type: 'pageRadioButton',
        instructions: [
            {
                instruction: messages.PREFERENCESPRO1,
            },
        ],
        value: '',
        key: 'PREF7',
        inputs: [
            {
                label: messages.PREFERENCESPRO7REPONSE1,
                valueKey: 'PREF_LEADERSHIP',
            },
            {
                label: messages.PREFERENCESPRO7REPONSE2,
                valueKey: 'PREF_INTELLECTUALSTIMULATION',
            },
        ]
    },

    {
        step: 42,
        inputNumber: 18,
        type: 'pageRadioButton',
        instructions: [
            {
                instruction: messages.PREFERENCESPRO1,
            },
        ],
        value: '',
        key: 'PREF8',
        inputs: [
            {
                label: messages.PREFERENCESPRO8REPONSE1,
                valueKey: 'PREF_SECURITY',
            },
            {
                label: messages.PREFERENCESPRO8REPONSE2,
                valueKey: 'PREF_TASKVARIABILITY',
            },
        ]
    },

    {
        step: 43,
        inputNumber: 19,
        type: 'pageRadioButton',
        instructions: [
            {
                instruction: messages.PREFERENCESPRO1,
            },
        ],
        value: '',
        key: 'PREF9',
        inputs: [
            {
                label: messages.PREFERENCESPRO9REPONSE1,
                valueKey: 'PREF_ENJOYWORK',
            },
            {
                label: messages.PREFERENCESPRO9REPONSE2,
                valueKey: 'PREF_SALARY',
            },
        ]
    },

    {
        step: 44,
        inputNumber: 20,
        type: 'pageRadioButton',
        instructions: [
            {
                instruction: messages.PREFERENCESPRO1,
            },
        ],
        value: '',
        key: 'PREF10',
        inputs: [
            {
                label: messages.PREFERENCESPRO10REPONSE1,
                valueKey: 'PREF_LEADERSHIP',
            },
            {
                label: messages.PREFERENCESPRO10REPONSE2,
                valueKey: 'PREF_SECURITY',
            },
        ]
    },

    {
        step: 45,
        inputNumber: 21,
        type: 'pageRadioButton',
        instructions: [
            {
                instruction: messages.PREFERENCESPRO1,
            },
        ],
        value: '',
        key: 'PREF11',
        inputs: [
            {
                label: messages.PREFERENCESPRO11REPONSE1,
                valueKey: 'PREF_SALARY',
            },
            {
                label: messages.PREFERENCESPRO11REPONSE2,
                valueKey: 'PREF_TASKVARIABILITY',
            },
        ]
    },

    {
        step: 46,
        inputNumber: 22,
        type: 'pageRadioButton',
        instructions: [
            {
                instruction: messages.PREFERENCESPRO1,
            },
        ],
        value: '',
        key: 'PREF12',
        inputs: [
            {
                label: messages.PREFERENCESPRO12REPONSE1,
                valueKey: 'PREF_INTELLECTUALSTIMULATION',
            },
            {
                label: messages.PREFERENCESPRO12REPONSE2,
                valueKey: 'PREF_ENJOYWORK',
            },
        ]
    },
    {
        step: 47,
        inputNumber: 23,
        type: 'pageRadioButton',
        instructions: [
            {
                instruction: messages.PREFERENCESPRO1,
            },
        ],
        value: '',
        key: 'PREF13',
        inputs: [
            {
                label: messages.PREFERENCESPRO13REPONSE1,
                valueKey: 'PREF_SECURITY',
            },
            {
                label: messages.PREFERENCESPRO13REPONSE2,
                valueKey: 'PREF_SALARY',
            },
        ]
    },
    {
        step: 49,
        inputNumber: 24,
        type: 'pageRadioButton',
        instructions: [
            {
                instruction: messages.PREFERENCESPRO1,
            },
        ],
        value: '',
        key: 'PREF14',
        inputs: [
            {
                label: messages.PREFERENCESPRO14REPONSE1,
                valueKey: 'PREF_ENJOYWORK',
            },
            {
                label: messages.PREFERENCESPRO14REPONSE2,
                valueKey: 'PREF_LEADERSHIP',
            },
        ]
    },

    {
        step: 50,
        inputNumber: 25,
        type: 'pageRadioButton',
        instructions: [
            {
                instruction: messages.PREFERENCESPRO1,
            },
        ],
        value: '',
        key: 'PREF15',
        inputs: [
            {
                label: messages.PREFERENCESPRO15REPONSE1,
                valueKey: 'PREF_TASKVARIABILITY',
            },
            {
                label: messages.PREFERENCESPRO15REPONSE2,
                valueKey: 'PREF_INTELLECTUALSTIMULATION',
            },
        ]
    },
    //fin preferences professionnels

    //début situation de crise (stratégie)
    {
        step: 51,
        type: 'informations',
        titre: messages.TITRE,
        titre1: messages.TITRE1,
        contenu: messages.INFO5,
        titre2: messages.TITRE2,
        consignes: [
            {
                consigne: messages.INFOINST5,
            },
        ]
    },

    //début situation stratégie
    {
        step: 52,
        inputNumber: 26,
        type: 'pageSituationStrategy',
        stepRange: 40,
        situationTitle: messages.SITUATIONCRISETITLE,
        strategyTitle: messages.STRATEGYCRISETITLE,
        situationText: messages.SITUATIONSCRISE,
        strategyTexts: [
            {
                strategyText: messages.STRATEGIECRISE1A,
            },
            {
                strategyText: messages.STRATEGIECRISE1B,
            },
            {
                strategyText: messages.STRATEGIECRISE1C,
            }
        ],
        question: messages.SITUATIONSCRISE1,
        value: 0,
        key: 'SS1',
        labelLvl: [
            {
                label1: messages.SITUATIONCRISELVL1,
                label2: messages.SITUATIONCRISELVL2,
                label3: messages.SITUATIONCRISELVL3,
                label4: messages.SITUATIONCRISELVL4,
                label5: messages.SITUATIONCRISELVL5,
                label6: messages.SITUATIONCRISELVL6,
            },
        ]
    },

    {
        step: 53,
        inputNumber: 27,
        type: 'pageSituationStrategy',
        stepRange: 40,
        situationTitle: messages.SITUATIONCRISETITLE,
        strategyTitle: messages.STRATEGYCRISETITLE,
        situationText: messages.SITUATIONSCRISE,
        strategyTexts: [
            {
                strategyText: messages.STRATEGIECRISE2A,
            },
            {
                strategyText: messages.STRATEGIECRISE2B,
            },
            {
                strategyText: messages.STRATEGIECRISE2C,
            }
        ],
        question: messages.SITUATIONSCRISE1,
        value: 0,
        key: 'SS2',
        labelLvl: [
            {
                label1: messages.SITUATIONCRISELVL1,
                label2: messages.SITUATIONCRISELVL2,
                label3: messages.SITUATIONCRISELVL3,
                label4: messages.SITUATIONCRISELVL4,
                label5: messages.SITUATIONCRISELVL5,
                label6: messages.SITUATIONCRISELVL6,
            },
        ]
    },


    {
        step: 54,
        inputNumber: 28,
        type: 'pageSituationStrategy',
        stepRange: 40,
        situationTitle: messages.SITUATIONCRISETITLE,
        strategyTitle: messages.STRATEGYCRISETITLE,
        situationText: messages.SITUATIONSCRISE,
        strategyTexts: [
            {
                strategyText: messages.STRATEGIECRISE3A,
            },
            {
                strategyText: messages.STRATEGIECRISE3B,
            },
            {
                strategyText: messages.STRATEGIECRISE3C,
            }
        ],
        question: messages.SITUATIONSCRISE1,
        value: 0,
        key: 'SS3',
        labelLvl: [
            {
                label1: messages.SITUATIONCRISELVL1,
                label2: messages.SITUATIONCRISELVL2,
                label3: messages.SITUATIONCRISELVL3,
                label4: messages.SITUATIONCRISELVL4,
                label5: messages.SITUATIONCRISELVL5,
                label6: messages.SITUATIONCRISELVL6,
            },
        ]
    },

    {
        step: 55,
        inputNumber: 29,
        type: 'pageSituationStrategy',
        stepRange: 40,
        situationTitle: messages.SITUATIONCRISETITLE,
        strategyTitle: messages.STRATEGYCRISETITLE,
        situationText: messages.SITUATIONSCRISE,
        strategyTexts: [
            {
                strategyText: messages.STRATEGIECRISE4A,
            },
            {
                strategyText: messages.STRATEGIECRISE4B,
            },
            {
                strategyText: messages.STRATEGIECRISE4C,
            }
        ],
        question: messages.SITUATIONSCRISE1,
        value: 0,
        key: 'SS4',
        labelLvl: [
            {
                label1: messages.SITUATIONCRISELVL1,
                label2: messages.SITUATIONCRISELVL2,
                label3: messages.SITUATIONCRISELVL3,
                label4: messages.SITUATIONCRISELVL4,
                label5: messages.SITUATIONCRISELVL5,
                label6: messages.SITUATIONCRISELVL6,
            },
        ]
    },

    {
        step: 56,
        inputNumber: 30,
        type: 'pageSituationStrategy',
        stepRange: 40,
        situationTitle: messages.SITUATIONCRISETITLE,
        strategyTitle: messages.STRATEGYCRISETITLE,
        situationText: messages.SITUATIONSCRISE,
        strategyTexts: [
            {
                strategyText: messages.STRATEGIECRISE5A,
            },
            {
                strategyText: messages.STRATEGIECRISE5B,
            },
            {
                strategyText: messages.STRATEGIECRISE5C,
            }
        ],
        question: messages.SITUATIONSCRISE1,
        value: 0,
        key: 'SS5',
        labelLvl: [
            {
                label1: messages.SITUATIONCRISELVL1,
                label2: messages.SITUATIONCRISELVL2,
                label3: messages.SITUATIONCRISELVL3,
                label4: messages.SITUATIONCRISELVL4,
                label5: messages.SITUATIONCRISELVL5,
                label6: messages.SITUATIONCRISELVL6,
            },
        ]
    },
    {
        step: 57,
        inputNumber: 31,
        type: 'pageSituationStrategy',
        stepRange: 40,
        situationTitle: messages.SITUATIONCRISETITLE,
        strategyTitle: messages.STRATEGYCRISETITLE,
        situationText: messages.SITUATIONSCRISE,
        strategyTexts: [
            {
                strategyText: messages.STRATEGIECRISE6A,
            },
            {
                strategyText: messages.STRATEGIECRISE6B,
            },
            {
                strategyText: messages.STRATEGIECRISE6C,
            }
        ],
        question: messages.SITUATIONSCRISE1,
        value: 0,
        key: 'SS6',
        labelLvl: [
            {
                label1: messages.SITUATIONCRISELVL1,
                label2: messages.SITUATIONCRISELVL2,
                label3: messages.SITUATIONCRISELVL3,
                label4: messages.SITUATIONCRISELVL4,
                label5: messages.SITUATIONCRISELVL5,
                label6: messages.SITUATIONCRISELVL6,
            },
        ]
    },

    {
        step: 58,
        inputNumber: 32,
        type: 'pageSituationStrategy',
        stepRange: 40,
        situationTitle: messages.SITUATIONCRISETITLE,
        strategyTitle: messages.STRATEGYCRISETITLE,
        situationText: messages.SITUATIONSCRISE,
        strategyTexts: [
            {
                strategyText: messages.STRATEGIECRISE7A,
            },
            {
                strategyText: messages.STRATEGIECRISE7B,
            },
            {
                strategyText: messages.STRATEGIECRISE7C,
            }
        ],
        question: messages.SITUATIONSCRISE1,
        value: 0,
        key: 'SS7',
        labelLvl: [
            {
                label1: messages.SITUATIONCRISELVL1,
                label2: messages.SITUATIONCRISELVL2,
                label3: messages.SITUATIONCRISELVL3,
                label4: messages.SITUATIONCRISELVL4,
                label5: messages.SITUATIONCRISELVL5,
                label6: messages.SITUATIONCRISELVL6,
            },
        ]
    },

    {
        step: 59,
        inputNumber: 33,
        type: 'pageSituationStrategy',
        stepRange: 40,
        situationTitle: messages.SITUATIONCRISETITLE,
        strategyTitle: messages.STRATEGYCRISETITLE,
        situationText: messages.SITUATIONSCRISE,
        strategyTexts: [
            {
                strategyText: messages.STRATEGIECRISE8A,
            },
            {
                strategyText: messages.STRATEGIECRISE8B,
            },
            {
                strategyText: messages.STRATEGIECRISE8C,
            }
        ],
        question: messages.SITUATIONSCRISE1,
        value: 0,
        key: 'SS8',
        labelLvl: [
            {
                label1: messages.SITUATIONCRISELVL1,
                label2: messages.SITUATIONCRISELVL2,
                label3: messages.SITUATIONCRISELVL3,
                label4: messages.SITUATIONCRISELVL4,
                label5: messages.SITUATIONCRISELVL5,
                label6: messages.SITUATIONCRISELVL6,
            },
        ]
    },

    {
        step: 60,
        inputNumber: 34,
        type: 'pageSituationStrategy',
        stepRange: 40,
        situationTitle: messages.SITUATIONCRISETITLE,
        strategyTitle: messages.STRATEGYCRISETITLE,
        situationText: messages.SITUATIONSCRISE,
        strategyTexts: [
            {
                strategyText: messages.STRATEGIECRISE9A,
            },
            {
                strategyText: messages.STRATEGIECRISE9B,
            },
            {
                strategyText: messages.STRATEGIECRISE9C,
            }
        ],
        question: messages.SITUATIONSCRISE1,
        value: 0,
        key: 'SS9',
        labelLvl: [
            {
                label1: messages.SITUATIONCRISELVL1,
                label2: messages.SITUATIONCRISELVL2,
                label3: messages.SITUATIONCRISELVL3,
                label4: messages.SITUATIONCRISELVL4,
                label5: messages.SITUATIONCRISELVL5,
                label6: messages.SITUATIONCRISELVL6,
            },
        ]
    },
    //fin situation stratégie


    //début préferences de vos tendances comportementales
    {
        step: 61,
        type: 'informations',
        titre: messages.TITRE,
        titre1: messages.TITRE1,
        contenu: messages.INFO6,
        titre2: messages.TITRE2,
        consignes: [
            {
                consigne: messages.INFOINST6,
            },
        ]
    },

    {
        step: 62,
        type: 'pageRadioButton',
        inputNumber: 35,
        information: messages.PREFERENCESTENDANCESQUESTION1,
        instructions: [
            {
                instruction: messages.PREFERENCESTENDANCES1,
            }
        ],
        value: '', // Mettre le profil ici
        key: 'PTC1',
        inputs: [
            {
                label: messages.RBPASDUTOUT,
                valueKey: '1',
            },
            {
                label: messages.RBAPEINE,
                valueKey: '2',
            },
            {
                label: messages.RBASSEZ,
                valueKey: '3',
            },
            {
                label: messages.RBTOUTAFAIT,
                valueKey: '4',
            },
        ]
    },

    {
        step: 63,
        type: 'pageRadioButton',
        inputNumber: 36,
        information: messages.PREFERENCESTENDANCESQUESTION1,
        instructions: [
            {
                instruction: messages.PREFERENCESTENDANCES2,
            }
        ],
        value: '', // Mettre le profil ici
        key: 'PTC2',
        inputs: [
            {
                label: messages.RBPASDUTOUT,
                valueKey: '1',
            },
            {
                label: messages.RBAPEINE,
                valueKey: '2',
            },
            {
                label: messages.RBASSEZ,
                valueKey: '3',
            },
            {
                label: messages.RBTOUTAFAIT,
                valueKey: '4',
            },
        ]
    },

    {
        step: 64,
        type: 'pageRadioButton',
        inputNumber: 37,
        information: messages.PREFERENCESTENDANCESQUESTION1,
        instructions: [
            {
                instruction: messages.PREFERENCESTENDANCES3,
            }
        ],
        value: '', // Mettre le profil ici
        key: 'PTC3',
        inputs: [
            {
                label: messages.RBPASDUTOUT,
                valueKey: '4',
            },
            {
                label: messages.RBAPEINE,
                valueKey: '3',
            },
            {
                label: messages.RBASSEZ,
                valueKey: '2',
            },
            {
                label: messages.RBTOUTAFAIT,
                valueKey: '1',
            },
        ]
    },

    {
        step: 65,
        type: 'pageRadioButton',
        inputNumber: 38,
        information: messages.PREFERENCESTENDANCESQUESTION1,
        instructions: [
            {
                instruction: messages.PREFERENCESTENDANCES4,
            }
        ],
        value: '', // Mettre le profil ici
        key: 'PTC4',
        inputs: [
            {
                label: messages.RBPASDUTOUT,
                valueKey: '1',
            },
            {
                label: messages.RBAPEINE,
                valueKey: '2',
            },
            {
                label: messages.RBASSEZ,
                valueKey: '3',
            },
            {
                label: messages.RBTOUTAFAIT,
                valueKey: '4',
            },
        ]
    },

    {
        step: 66,
        type: 'pageRadioButton',
        inputNumber: 39,
        information: messages.PREFERENCESTENDANCESQUESTION1,
        instructions: [
            {
                instruction: messages.PREFERENCESTENDANCES5,
            }
        ],
        value: '', // Mettre le profil ici
        key: 'PTC5',
        inputs: [
            {
                label: messages.RBPASDUTOUT,
                valueKey: '4',
            },
            {
                label: messages.RBAPEINE,
                valueKey: '3',
            },
            {
                label: messages.RBASSEZ,
                valueKey: '2',
            },
            {
                label: messages.RBTOUTAFAIT,
                valueKey: '1',
            },
        ]
    },

    {
        step: 67,
        type: 'pageRadioButton',
        inputNumber: 40,
        information: messages.PREFERENCESTENDANCESQUESTION1,
        instructions: [
            {
                instruction: messages.PREFERENCESTENDANCES6,
            }
        ],
        value: '', // Mettre le profil ici
        key: 'PTC6',
        inputs: [
            {
                label: messages.RBPASDUTOUT,
                valueKey: '1',
            },
            {
                label: messages.RBAPEINE,
                valueKey: '2',
            },
            {
                label: messages.RBASSEZ,
                valueKey: '3',
            },
            {
                label: messages.RBTOUTAFAIT,
                valueKey: '4',
            },
        ]
    },

    {
        step: 68,
        type: 'pageRadioButton',
        inputNumber: 41,
        information: messages.PREFERENCESTENDANCESQUESTION1,
        instructions: [
            {
                instruction: messages.PREFERENCESTENDANCES7,
            }
        ],
        value: '', // Mettre le profil ici
        key: 'PTC7',
        inputs: [
            {
                label: messages.RBPASDUTOUT,
                valueKey: '1',
            },
            {
                label: messages.RBAPEINE,
                valueKey: '2',
            },
            {
                label: messages.RBASSEZ,
                valueKey: '3',
            },
            {
                label: messages.RBTOUTAFAIT,
                valueKey: '4',
            },
        ]
    },

    {
        step: 69,
        type: 'pageRadioButton',
        inputNumber: 42,
        information: messages.PREFERENCESTENDANCESQUESTION1,
        instructions: [
            {
                instruction: messages.PREFERENCESTENDANCES8,
            }
        ],
        value: '', // Mettre le profil ici
        key: 'PTC8',
        inputs: [
            {
                label: messages.RBPASDUTOUT,
                valueKey: '1',
            },
            {
                label: messages.RBAPEINE,
                valueKey: '2',
            },
            {
                label: messages.RBASSEZ,
                valueKey: '3',
            },
            {
                label: messages.RBTOUTAFAIT,
                valueKey: '4',
            },
        ]
    },

    {
        step: 70,
        type: 'pageRadioButton',
        inputNumber: 43,
        information: messages.PREFERENCESTENDANCESQUESTION1,
        instructions: [
            {
                instruction: messages.PREFERENCESTENDANCES9,
            }
        ],
        value: '', // Mettre le profil ici
        key: 'PTC9',
        inputs: [
            {
                label: messages.RBPASDUTOUT,
                valueKey: '1',
            },
            {
                label: messages.RBAPEINE,
                valueKey: '2',
            },
            {
                label: messages.RBASSEZ,
                valueKey: '3',
            },
            {
                label: messages.RBTOUTAFAIT,
                valueKey: '4',
            },
        ]
    },
    {
        step: 71,
        type: 'pageRadioButton',
        inputNumber: 44,
        information: messages.PREFERENCESTENDANCESQUESTION1,
        instructions: [
            {
                instruction: messages.PREFERENCESTENDANCES10,
            }
        ],
        value: '', // Mettre le profil ici
        key: 'PTC10',
        inputs: [
            {
                label: messages.RBPASDUTOUT,
                valueKey: '4',
            },
            {
                label: messages.RBAPEINE,
                valueKey: '3',
            },
            {
                label: messages.RBASSEZ,
                valueKey: '2',
            },
            {
                label: messages.RBTOUTAFAIT,
                valueKey: '1',
            },
        ]
    },
    {
        step: 72,
        type: 'pageRadioButton',
        inputNumber: 45,
        information: messages.PREFERENCESTENDANCESQUESTION1,
        instructions: [
            {
                instruction: messages.PREFERENCESTENDANCES11,
            }
        ],
        value: '', // Mettre le profil ici
        key: 'PTC11',
        inputs: [
            {
                label: messages.RBPASDUTOUT,
                valueKey: '4',
            },
            {
                label: messages.RBAPEINE,
                valueKey: '3',
            },
            {
                label: messages.RBASSEZ,
                valueKey: '2',
            },
            {
                label: messages.RBTOUTAFAIT,
                valueKey: '1',
            },
        ]
    },
    {
        step: 73,
        type: 'pageRadioButton',
        inputNumber: 46,
        information: messages.PREFERENCESTENDANCESQUESTION1,
        instructions: [
            {
                instruction: messages.PREFERENCESTENDANCES12,
            }
        ],
        value: '', // Mettre le profil ici
        key: 'PTC12',
        inputs: [
            {
                label: messages.RBPASDUTOUT,
                valueKey: '4',
            },
            {
                label: messages.RBAPEINE,
                valueKey: '3',
            },
            {
                label: messages.RBASSEZ,
                valueKey: '2',
            },
            {
                label: messages.RBTOUTAFAIT,
                valueKey: '1',
            },
        ]
    },
    {
        step: 74,
        type: 'pageRadioButton',
        inputNumber: 47,
        information: messages.PREFERENCESTENDANCESQUESTION1,
        instructions: [
            {
                instruction: messages.PREFERENCESTENDANCES13,
            }
        ],
        value: '', // Mettre le profil ici
        key: 'PTC13',
        inputs: [
            {
                label: messages.RBPASDUTOUT,
                valueKey: '1',
            },
            {
                label: messages.RBAPEINE,
                valueKey: '2',
            },
            {
                label: messages.RBASSEZ,
                valueKey: '3',
            },
            {
                label: messages.RBTOUTAFAIT,
                valueKey: '4',
            },
        ]
    },
    {
        step: 75,
        type: 'pageRadioButton',
        inputNumber: 48,
        information: messages.PREFERENCESTENDANCESQUESTION1,
        instructions: [
            {
                instruction: messages.PREFERENCESTENDANCES14,
            }
        ],
        value: '', // Mettre le profil ici
        key: 'PTC14',
        inputs: [
            {
                label: messages.RBPASDUTOUT,
                valueKey: '1',
            },
            {
                label: messages.RBAPEINE,
                valueKey: '2',
            },
            {
                label: messages.RBASSEZ,
                valueKey: '3',
            },
            {
                label: messages.RBTOUTAFAIT,
                valueKey: '4',
            },
        ]
    },
    {
        step: 76,
        type: 'pageRadioButton',
        inputNumber: 49,
        information: messages.PREFERENCESTENDANCESQUESTION1,
        instructions: [
            {
                instruction: messages.PREFERENCESTENDANCES15,
            }
        ],
        value: '', // Mettre le profil ici
        key: 'PTC15',
        inputs: [
            {
                label: messages.RBPASDUTOUT,
                valueKey: '4',
            },
            {
                label: messages.RBAPEINE,
                valueKey: '3',
            },
            {
                label: messages.RBASSEZ,
                valueKey: '2',
            },
            {
                label: messages.RBTOUTAFAIT,
                valueKey: '1',
            },
        ]
    },
    {
        step: 77,
        type: 'pageRadioButton',
        inputNumber: 50,
        information: messages.PREFERENCESTENDANCESQUESTION1,
        instructions: [
            {
                instruction: messages.PREFERENCESTENDANCES16,
            }
        ],
        value: '', // Mettre le profil ici
        key: 'PTC16',
        inputs: [
            {
                label: messages.RBPASDUTOUT,
                valueKey: '1',
            },
            {
                label: messages.RBAPEINE,
                valueKey: '2',
            },
            {
                label: messages.RBASSEZ,
                valueKey: '3',
            },
            {
                label: messages.RBTOUTAFAIT,
                valueKey: '4',
            },
        ]
    },
    {
        step: 78,
        type: 'pageRadioButton',
        inputNumber: 51,
        information: messages.PREFERENCESTENDANCESQUESTION1,
        instructions: [
            {
                instruction: messages.PREFERENCESTENDANCES17,
            }
        ],
        value: '', // Mettre le profil ici
        key: 'PTC17',
        inputs: [
            {
                label: messages.RBPASDUTOUT,
                valueKey: '1',
            },
            {
                label: messages.RBAPEINE,
                valueKey: '2',
            },
            {
                label: messages.RBASSEZ,
                valueKey: '3',
            },
            {
                label: messages.RBTOUTAFAIT,
                valueKey: '4',
            },
        ]
    },
    {
        step: 79,
        type: 'pageRadioButton',
        inputNumber: 52,
        information: messages.PREFERENCESTENDANCESQUESTION1,
        instructions: [
            {
                instruction: messages.PREFERENCESTENDANCES18,
            }
        ],
        value: '', // Mettre le profil ici
        key: 'PTC18',
        inputs: [
            {
                label: messages.RBPASDUTOUT,
                valueKey: '4',
            },
            {
                label: messages.RBAPEINE,
                valueKey: '3',
            },
            {
                label: messages.RBASSEZ,
                valueKey: '2',
            },
            {
                label: messages.RBTOUTAFAIT,
                valueKey: '1',
            },
        ]
    },
    {
        step: 80,
        type: 'pageRadioButton',
        inputNumber: 53,
        information: messages.PREFERENCESTENDANCESQUESTION1,
        instructions: [
            {
                instruction: messages.PREFERENCESTENDANCES19,
            }
        ],
        value: '', // Mettre le profil ici
        key: 'PTC19',
        inputs: [
            {
                label: messages.RBPASDUTOUT,
                valueKey: '1',
            },
            {
                label: messages.RBAPEINE,
                valueKey: '2',
            },
            {
                label: messages.RBASSEZ,
                valueKey: '3',
            },
            {
                label: messages.RBTOUTAFAIT,
                valueKey: '4',
            },
        ]
    },

    {
        step: 81,
        type: 'pageRadioButton',
        inputNumber: 54,
        information: messages.PREFERENCESTENDANCESQUESTION1,
        instructions: [
            {
                instruction: messages.PREFERENCESTENDANCES20,
            }
        ],
        value: '', // Mettre le profil ici
        key: 'PTC20',
        inputs: [
            {
                label: messages.RBPASDUTOUT,
                valueKey: '1',
            },
            {
                label: messages.RBAPEINE,
                valueKey: '2',
            },
            {
                label: messages.RBASSEZ,
                valueKey: '3',
            },
            {
                label: messages.RBTOUTAFAIT,
                valueKey: '4',
            },
        ]
    },

    {
        step: 82,
        type: 'pageRadioButton',
        inputNumber: 55,
        information: messages.PREFERENCESTENDANCESQUESTION1,
        instructions: [
            {
                instruction: messages.PREFERENCESTENDANCES21,
            }
        ],
        value: '', // Mettre le profil ici
        key: 'PTC21',
        inputs: [
            {
                label: messages.RBPASDUTOUT,
                valueKey: '1',
            },
            {
                label: messages.RBAPEINE,
                valueKey: '2',
            },
            {
                label: messages.RBASSEZ,
                valueKey: '3',
            },
            {
                label: messages.RBTOUTAFAIT,
                valueKey: '4',
            },
        ]
    },

    {
        step: 83,
        type: 'pageRadioButton',
        inputNumber: 56,
        information: messages.PREFERENCESTENDANCESQUESTION1,
        instructions: [
            {
                instruction: messages.PREFERENCESTENDANCES22,
            }
        ],
        value: '', // Mettre le profil ici
        key: 'PTC22',
        inputs: [
            {
                label: messages.RBPASDUTOUT,
                valueKey: '1',
            },
            {
                label: messages.RBAPEINE,
                valueKey: '2',
            },
            {
                label: messages.RBASSEZ,
                valueKey: '3',
            },
            {
                label: messages.RBTOUTAFAIT,
                valueKey: '4',
            },
        ]
    },

    {
        step: 84,
        type: 'pageRadioButton',
        inputNumber: 57,
        information: messages.PREFERENCESTENDANCESQUESTION1,
        instructions: [
            {
                instruction: messages.PREFERENCESTENDANCES23,
            }
        ],
        value: '', // Mettre le profil ici
        key: 'PTC23',
        inputs: [
            {
                label: messages.RBPASDUTOUT,
                valueKey: '1',
            },
            {
                label: messages.RBAPEINE,
                valueKey: '2',
            },
            {
                label: messages.RBASSEZ,
                valueKey: '3',
            },
            {
                label: messages.RBTOUTAFAIT,
                valueKey: '4',
            },
        ]
    },

    {
        step: 85,
        type: 'pageRadioButton',
        inputNumber: 58,
        information: messages.PREFERENCESTENDANCESQUESTION1,
        instructions: [
            {
                instruction: messages.PREFERENCESTENDANCES24,
            }
        ],
        value: '', // Mettre le profil ici
        key: 'PTC24',
        inputs: [
            {
                label: messages.RBPASDUTOUT,
                valueKey: '4',
            },
            {
                label: messages.RBAPEINE,
                valueKey: '3',
            },
            {
                label: messages.RBASSEZ,
                valueKey: '2',
            },
            {
                label: messages.RBTOUTAFAIT,
                valueKey: '1',
            },
        ]
    },

    {
        step: 86,
        type: 'pageRadioButton',
        inputNumber: 59,
        information: messages.PREFERENCESTENDANCESQUESTION1,
        instructions: [
            {
                instruction: messages.PREFERENCESTENDANCES25,
            }
        ],
        value: '', // Mettre le profil ici
        key: 'PTC25',
        inputs: [
            {
                label: messages.RBPASDUTOUT,
                valueKey: '4',
            },
            {
                label: messages.RBAPEINE,
                valueKey: '3',
            },
            {
                label: messages.RBASSEZ,
                valueKey: '2',
            },
            {
                label: messages.RBTOUTAFAIT,
                valueKey: '1',
            },
        ]
    },
    {
        step: 87,
        type: 'pageRadioButton',
        inputNumber: 60,
        information: messages.PREFERENCESTENDANCESQUESTION1,
        instructions: [
            {
                instruction: messages.PREFERENCESTENDANCES26,
            }
        ],
        value: '', // Mettre le profil ici
        key: 'PTC26',
        inputs: [
            {
                label: messages.RBPASDUTOUT,
                valueKey: '1',
            },
            {
                label: messages.RBAPEINE,
                valueKey: '2',
            },
            {
                label: messages.RBASSEZ,
                valueKey: '3',
            },
            {
                label: messages.RBTOUTAFAIT,
                valueKey: '4',
            },
        ]
    },

    {
        step: 88,
        type: 'pageRadioButton',
        inputNumber: 61,
        information: messages.PREFERENCESTENDANCESQUESTION1,
        instructions: [
            {
                instruction: messages.PREFERENCESTENDANCES27,
            }
        ],
        value: '', // Mettre le profil ici
        key: 'PTC27',
        inputs: [
            {
                label: messages.RBPASDUTOUT,
                valueKey: '1',
            },
            {
                label: messages.RBAPEINE,
                valueKey: '2',
            },
            {
                label: messages.RBASSEZ,
                valueKey: '3',
            },
            {
                label: messages.RBTOUTAFAIT,
                valueKey: '4',
            },
        ]
    },

    {
        step: 89,
        type: 'pageRadioButton',
        inputNumber: 62,
        information: messages.PREFERENCESTENDANCESQUESTION1,
        instructions: [
            {
                instruction: messages.PREFERENCESTENDANCES28,
            }
        ],
        value: '', // Mettre le profil ici
        key: 'PTC28',
        inputs: [
            {
                label: messages.RBPASDUTOUT,
                valueKey: '4',
            },
            {
                label: messages.RBAPEINE,
                valueKey: '3',
            },
            {
                label: messages.RBASSEZ,
                valueKey: '2',
            },
            {
                label: messages.RBTOUTAFAIT,
                valueKey: '1',
            },
        ]
    },

    {
        step: 90,
        type: 'pageRadioButton',
        inputNumber: 63,
        information: messages.PREFERENCESTENDANCESQUESTION1,
        instructions: [
            {
                instruction: messages.PREFERENCESTENDANCES29,
            }
        ],
        value: '', // Mettre le profil ici
        key: 'PTC29',
        inputs: [
            {
                label: messages.RBPASDUTOUT,
                valueKey: '1',
            },
            {
                label: messages.RBAPEINE,
                valueKey: '2',
            },
            {
                label: messages.RBASSEZ,
                valueKey: '3',
            },
            {
                label: messages.RBTOUTAFAIT,
                valueKey: '4',
            },
        ]
    },

    {
        step: 91,
        type: 'pageRadioButton',
        inputNumber: 64,
        information: messages.PREFERENCESTENDANCESQUESTION1,
        instructions: [
            {
                instruction: messages.PREFERENCESTENDANCES30,
            }
        ],
        value: '', // Mettre le profil ici
        key: 'PTC30',
        inputs: [
            {
                label: messages.RBPASDUTOUT,
                valueKey: '1',
            },
            {
                label: messages.RBAPEINE,
                valueKey: '2',
            },
            {
                label: messages.RBASSEZ,
                valueKey: '3',
            },
            {
                label: messages.RBTOUTAFAIT,
                valueKey: '4',
            },
        ]
    },

    {
        step: 92,
        type: 'pageRadioButton',
        inputNumber: 65,
        information: messages.PREFERENCESTENDANCESQUESTION1,
        instructions: [
            {
                instruction: messages.PREFERENCESTENDANCES31,
            }
        ],
        value: '', // Mettre le profil ici
        key: 'PTC31',
        inputs: [
            {
                label: messages.RBPASDUTOUT,
                valueKey: '1',
            },
            {
                label: messages.RBAPEINE,
                valueKey: '2',
            },
            {
                label: messages.RBASSEZ,
                valueKey: '3',
            },
            {
                label: messages.RBTOUTAFAIT,
                valueKey: '4',
            },
        ]
    },

    {
        step: 93,
        type: 'pageRadioButton',
        inputNumber: 66,
        information: messages.PREFERENCESTENDANCESQUESTION1,
        instructions: [
            {
                instruction: messages.PREFERENCESTENDANCES32,
            }
        ],
        value: '', // Mettre le profil ici
        key: 'PTC32',
        inputs: [
            {
                label: messages.RBPASDUTOUT,
                valueKey: '1',
            },
            {
                label: messages.RBAPEINE,
                valueKey: '2',
            },
            {
                label: messages.RBASSEZ,
                valueKey: '3',
            },
            {
                label: messages.RBTOUTAFAIT,
                valueKey: '4',
            },
        ]
    },
    {
        step: 94,
        type: 'pageRadioButton',
        inputNumber: 67,
        information: messages.PREFERENCESTENDANCESQUESTION1,
        instructions: [
            {
                instruction: messages.PREFERENCESTENDANCES33,
            }
        ],
        value: '', // Mettre le profil ici
        key: 'PTC33',
        inputs: [
            {
                label: messages.RBPASDUTOUT,
                valueKey: '4',
            },
            {
                label: messages.RBAPEINE,
                valueKey: '3',
            },
            {
                label: messages.RBASSEZ,
                valueKey: '2',
            },
            {
                label: messages.RBTOUTAFAIT,
                valueKey: '1',
            },
        ]
    },
    {
        step: 95,
        type: 'pageRadioButton',
        inputNumber: 68,
        information: messages.PREFERENCESTENDANCESQUESTION1,
        instructions: [
            {
                instruction: messages.PREFERENCESTENDANCES34,
            }
        ],
        value: '', // Mettre le profil ici
        key: 'PTC34',
        inputs: [
            {
                label: messages.RBPASDUTOUT,
                valueKey: '1',
            },
            {
                label: messages.RBAPEINE,
                valueKey: '2',
            },
            {
                label: messages.RBASSEZ,
                valueKey: '3',
            },
            {
                label: messages.RBTOUTAFAIT,
                valueKey: '4',
            },
        ]
    },
    {
        step: 96,
        type: 'pageRadioButton',
        inputNumber: 69,
        information: messages.PREFERENCESTENDANCESQUESTION1,
        instructions: [
            {
                instruction: messages.PREFERENCESTENDANCES35,
            }
        ],
        value: '', // Mettre le profil ici
        key: 'PTC35',
        inputs: [
            {
                label: messages.RBPASDUTOUT,
                valueKey: '1',
            },
            {
                label: messages.RBAPEINE,
                valueKey: '2',
            },
            {
                label: messages.RBASSEZ,
                valueKey: '3',
            },
            {
                label: messages.RBTOUTAFAIT,
                valueKey: '4',
            },
        ]
    },

    {
        step: 97,
        type: 'pageRadioButton',
        inputNumber: 70,
        information: messages.PREFERENCESTENDANCESQUESTION1,
        instructions: [
            {
                instruction: messages.PREFERENCESTENDANCES36,
            }
        ],
        value: '', // Mettre le profil ici
        key: 'PTC36',
        inputs: [
            {
                label: messages.RBPASDUTOUT,
                valueKey: '1',
            },
            {
                label: messages.RBAPEINE,
                valueKey: '2',
            },
            {
                label: messages.RBASSEZ,
                valueKey: '3',
            },
            {
                label: messages.RBTOUTAFAIT,
                valueKey: '4',
            },
        ]
    },
    {
        step: 98,
        type: 'pageRadioButton',
        inputNumber: 71,
        information: messages.PREFERENCESTENDANCESQUESTION1,
        instructions: [
            {
                instruction: messages.PREFERENCESTENDANCES37,
            }
        ],
        value: '', // Mettre le profil ici
        key: 'PTC37',
        inputs: [
            {
                label: messages.RBPASDUTOUT,
                valueKey: '1',
            },
            {
                label: messages.RBAPEINE,
                valueKey: '2',
            },
            {
                label: messages.RBASSEZ,
                valueKey: '3',
            },
            {
                label: messages.RBTOUTAFAIT,
                valueKey: '4',
            },
        ]
    },
    {
        step: 99,
        type: 'pageRadioButton',
        inputNumber: 72,
        information: messages.PREFERENCESTENDANCESQUESTION1,
        instructions: [
            {
                instruction: messages.PREFERENCESTENDANCES38,
            }
        ],
        value: '', // Mettre le profil ici
        key: 'PTC38',
        inputs: [
            {
                label: messages.RBPASDUTOUT,
                valueKey: '1',
            },
            {
                label: messages.RBAPEINE,
                valueKey: '2',
            },
            {
                label: messages.RBASSEZ,
                valueKey: '3',
            },
            {
                label: messages.RBTOUTAFAIT,
                valueKey: '4',
            },
        ]
    },
    {
        step: 100,
        type: 'pageRadioButton',
        inputNumber: 73,
        information: messages.PREFERENCESTENDANCESQUESTION1,
        instructions: [
            {
                instruction: messages.PREFERENCESTENDANCES39,
            }
        ],
        value: '', // Mettre le profil ici
        key: 'PTC39',
        inputs: [
            {
                label: messages.RBPASDUTOUT,
                valueKey: '1',
            },
            {
                label: messages.RBAPEINE,
                valueKey: '2',
            },
            {
                label: messages.RBASSEZ,
                valueKey: '3',
            },
            {
                label: messages.RBTOUTAFAIT,
                valueKey: '4',
            },
        ]
    },
    //fin préferences comportementales


    // La nature de vos reactions émotionnelles
    {
        step: 101,
        type: 'informations',
        titre: messages.TITRE,
        titre1: messages.TITRE1,
        contenu: messages.INFO7,
        titre2: messages.TITRE2,
        consignes: [
            {
                consigne: messages.INFOINST7,
            },
        ]
    },
    {
        step: 102,
        inputNumber: 74,
        type: 'pageMultiSlider',
        stepRange: 33,
        situationText: messages.REACTIONSEMO1,
        question: messages.REACTIONSEMOCONSIGNE2,
        pasDuToutText: messages.REACTIONSEMOPASDUTOUT,
        tresFortementText: messages.REACTIONSEMOTRESFORTEMENT,
        inputsMS: [
            {
                labelMS: messages.REACTIONSEMO1POSSIBILITE1,
                value: '0',
                key: 'REACTIONSEMO1POSSIBILITE1',
                afficherNiveau: true,
            },
            {
                labelMS: messages.REACTIONSEMO1POSSIBILITE2,
                value: '0',
                key: 'REACTIONSEMO1POSSIBILITE2',
                afficherNiveau: false,
            },
            {
                labelMS: messages.REACTIONSEMO1POSSIBILITE3,
                value: '0',
                key: 'REACTIONSEMO1POSSIBILITE3',
                afficherNiveau: false,
            },
            {
                labelMS: messages.REACTIONSEMO1POSSIBILITE4,
                value: '0',
                key: 'REACTIONSEMO1POSSIBILITE4',
                afficherNiveau: false,
            },
            {
                labelMS: messages.REACTIONSEMO1POSSIBILITE5,
                value: '0',
                key: 'REACTIONSEMO1POSSIBILITE5',
                afficherNiveau: false,
            },
        ],
    },
    {
        step: 103,
        inputNumber: 75,
        type: 'pageMultiSlider',
        stepRange: 33,
        situationText: messages.REACTIONSEMO2,
        question: messages.REACTIONSEMOCONSIGNE2,
        pasDuToutText: messages.REACTIONSEMOPASDUTOUT,
        tresFortementText: messages.REACTIONSEMOTRESFORTEMENT,
        inputsMS: [
            {
                labelMS: messages.REACTIONSEMO1POSSIBILITE1,
                value: '0',
                key: 'REACTIONSEMO2POSSIBILITE1',
                afficherNiveau: true,
            },
            {
                labelMS: messages.REACTIONSEMO1POSSIBILITE2,
                value: '0',
                key: 'REACTIONSEMO2POSSIBILITE2',
                afficherNiveau: false,
            },
            {
                labelMS: messages.REACTIONSEMO1POSSIBILITE3,
                value: '0',
                key: 'REACTIONSEMO2POSSIBILITE3',
                afficherNiveau: false,
            },
            {
                labelMS: messages.REACTIONSEMO1POSSIBILITE4,
                value: '0',
                key: 'REACTIONSEMO2POSSIBILITE4',
                afficherNiveau: false,
            },
            {
                labelMS: messages.REACTIONSEMO1POSSIBILITE5,
                value: '0',
                key: 'REACTIONSEMO2POSSIBILITE5',
                afficherNiveau: false,
            },
        ],
    },
    {
        step: 104,
        inputNumber: 76,
        type: 'pageMultiSlider',
        stepRange: 33,
        situationText: messages.REACTIONSEMO3,
        question: messages.REACTIONSEMOCONSIGNE2,
        pasDuToutText: messages.REACTIONSEMOPASDUTOUT,
        tresFortementText: messages.REACTIONSEMOTRESFORTEMENT,
        inputsMS: [
            {
                labelMS: messages.REACTIONSEMO1POSSIBILITE1,
                value: '0',
                key: 'REACTIONSEMO3POSSIBILITE1',
                afficherNiveau: true,
            },
            {
                labelMS: messages.REACTIONSEMO1POSSIBILITE2,
                value: '0',
                key: 'REACTIONSEMO3POSSIBILITE2',
                afficherNiveau: false,
            },
            {
                labelMS: messages.REACTIONSEMO1POSSIBILITE3,
                value: '0',
                key: 'REACTIONSEMO3POSSIBILITE3',
                afficherNiveau: false,
            },
            {
                labelMS: messages.REACTIONSEMO1POSSIBILITE4,
                value: '0',
                key: 'REACTIONSEMO3POSSIBILITE4',
                afficherNiveau: false,
            },
            {
                labelMS: messages.REACTIONSEMO1POSSIBILITE5,
                value: '0',
                key: 'REACTIONSEMO3POSSIBILITE5',
                afficherNiveau: false,
            },
        ],
    },
    {
        step: 105,
        inputNumber: 77,
        type: 'pageMultiSlider',
        stepRange: 33,
        situationText: messages.REACTIONSEMO4,
        question: messages.REACTIONSEMOCONSIGNE2,
        pasDuToutText: messages.REACTIONSEMOPASDUTOUT,
        tresFortementText: messages.REACTIONSEMOTRESFORTEMENT,
        inputsMS: [
            {
                labelMS: messages.REACTIONSEMO1POSSIBILITE1,
                value: '0',
                key: 'REACTIONSEMO4POSSIBILITE1',
                afficherNiveau: true,
            },
            {
                labelMS: messages.REACTIONSEMO1POSSIBILITE2,
                value: '0',
                key: 'REACTIONSEMO4POSSIBILITE2',
                afficherNiveau: false,
            },
            {
                labelMS: messages.REACTIONSEMO1POSSIBILITE3,
                value: '0',
                key: 'REACTIONSEMO4POSSIBILITE3',
                afficherNiveau: false,
            },
            {
                labelMS: messages.REACTIONSEMO1POSSIBILITE4,
                value: '0',
                key: 'REACTIONSEMO4POSSIBILITE4',
                afficherNiveau: false,
            },
            {
                labelMS: messages.REACTIONSEMO1POSSIBILITE5,
                value: '0',
                key: 'REACTIONSEMO4POSSIBILITE5',
                afficherNiveau: false,
            },
        ],
    },
    {
        step: 106,
        inputNumber: 78,
        type: 'pageMultiSlider',
        stepRange: 33,
        situationText: messages.REACTIONSEMO5,
        question: messages.REACTIONSEMOCONSIGNE2,
        pasDuToutText: messages.REACTIONSEMOPASDUTOUT,
        tresFortementText: messages.REACTIONSEMOTRESFORTEMENT,
        inputsMS: [
            {
                labelMS: messages.REACTIONSEMO1POSSIBILITE1,
                value: '0',
                key: 'REACTIONSEMO5POSSIBILITE1',
                afficherNiveau: true,
            },
            {
                labelMS: messages.REACTIONSEMO1POSSIBILITE2,
                value: '0',
                key: 'REACTIONSEMO5POSSIBILITE2',
                afficherNiveau: false,
            },
            {
                labelMS: messages.REACTIONSEMO1POSSIBILITE3,
                value: '0',
                key: 'REACTIONSEMO5POSSIBILITE3',
                afficherNiveau: false,
            },
            {
                labelMS: messages.REACTIONSEMO1POSSIBILITE4,
                value: '0',
                key: 'REACTIONSEMO5POSSIBILITE4',
                afficherNiveau: false,
            },
            {
                labelMS: messages.REACTIONSEMO1POSSIBILITE5,
                value: '0',
                key: 'REACTIONSEMO5POSSIBILITE5',
                afficherNiveau: false,
            },
        ],
    },
    //fin réaction émotions

    //test de logique
    {
        step: 107,
        type: 'informations',
        titre: messages.TITRE,
        titre1: messages.TITRE1,
        contenu: messages.INFO8,
        titre2: messages.TITRE2,
        consignes: [
            {
                consigne: messages.INFOINST8,
            },
        ]
    },

    {
        step: 108,
        inputNumber: 79,
        type: 'pageCheckBox',
        pageTitleType: messages.TESTLOGIQUEAFFIRMATIONTITLE,
        pageTitleInfos: [
            {
                info: messages.TESTLOGIQUE2AFFIRMATIONA,
            },
            {
                info: messages.TESTLOGIQUE2AFFIRMATIONB,
            }
        ],
        aide: messages.AIDECHECKBOX,
        inputsCB: [
            {
                labelCB: messages.TESTLOGIQUE2DEDUCTIONS1,
                value: false,
                key: 'TESTLOGIQUE2DEDUCTIONS1',
            },
            {
                labelCB: messages.TESTLOGIQUE2DEDUCTIONS2,
                value: false,
                key: 'TESTLOGIQUE2DEDUCTIONS2',
            },
            {
                labelCB: messages.TESTLOGIQUE2DEDUCTIONS3,
                value: false,
                key: 'TESTLOGIQUE2DEDUCTIONS3',
            },
            {
                labelCB: messages.TESTLOGIQUE2DEDUCTIONS4,
                value: false,
                key: 'TESTLOGIQUE2DEDUCTIONS4',
            },
            {
                labelCB: messages.TESTLOGIQUE2DEDUCTIONS5,
                value: false,
                key: 'TESTLOGIQUE2DEDUCTIONS5',
            },
            {
                labelCB: messages.TESTLOGIQUE2DEDUCTIONS6,
                value: false,
                key: 'TESTLOGIQUE2DEDUCTIONS6',
            }
        ],
    },

    {
        step: 109,
        inputNumber: 80,
        type: 'pageCheckBox',
        pageTitleType: messages.TESTLOGIQUEAFFIRMATIONTITLE,
        pageTitleInfos: [
            {
                info: messages.TESTLOGIQUE3AFFIRMATIONA,
            },
            {
                info: messages.TESTLOGIQUE3AFFIRMATIONB,
            }
        ],
        aide: messages.AIDECHECKBOX,
        inputsCB: [
            {
                labelCB: messages.TESTLOGIQUE3DEDUCTIONS1,
                value: false,
                key: 'TESTLOGIQUE3DEDUCTIONS1',
            },
            {
                labelCB: messages.TESTLOGIQUE3DEDUCTIONS2,
                value: false,
                key: 'TESTLOGIQUE3DEDUCTIONS2',
            },
            {
                labelCB: messages.TESTLOGIQUE3DEDUCTIONS3,
                value: false,
                key: 'TESTLOGIQUE3DEDUCTIONS3',
            },
            {
                labelCB: messages.TESTLOGIQUE3DEDUCTIONS4,
                value: false,
                key: 'TESTLOGIQUE3DEDUCTIONS4',
            },
            {
                labelCB: messages.TESTLOGIQUE3DEDUCTIONS5,
                value: false,
                key: 'TESTLOGIQUE3DEDUCTIONS5',
            },
            {
                labelCB: messages.TESTLOGIQUE3DEDUCTIONS6,
                value: false,
                key: 'TESTLOGIQUE3DEDUCTIONS6',
            }
        ],
    },

    {
        step: 110,
        inputNumber: 81,
        type: 'pageCheckBox',
        pageTitleType: messages.TESTLOGIQUEAFFIRMATIONTITLE,
        pageTitleInfos: [
            {
                info: messages.TESTLOGIQUE4AFFIRMATIONA,
            },
            {
                info: messages.TESTLOGIQUE4AFFIRMATIONB,
            }
        ],
        aide: messages.AIDECHECKBOX,
        inputsCB: [
            {
                labelCB: messages.TESTLOGIQUE4DEDUCTIONS1,
                value: false,
                key: 'TESTLOGIQUE4DEDUCTIONS1',
            },
            {
                labelCB: messages.TESTLOGIQUE4DEDUCTIONS2,
                value: false,
                key: 'TESTLOGIQUE4DEDUCTIONS2',
            },
            {
                labelCB: messages.TESTLOGIQUE4DEDUCTIONS3,
                value: false,
                key: 'TESTLOGIQUE4DEDUCTIONS3',
            },
            {
                labelCB: messages.TESTLOGIQUE4DEDUCTIONS4,
                value: false,
                key: 'TESTLOGIQUE4DEDUCTIONS4',
            },
            {
                labelCB: messages.TESTLOGIQUE4DEDUCTIONS5,
                value: false,
                key: 'TESTLOGIQUE4DEDUCTIONS5',
            },
            {
                labelCB: messages.TESTLOGIQUE4DEDUCTIONS6,
                value: false,
                key: 'TESTLOGIQUE4DEDUCTIONS6',
            }
        ],
    },

    //fin test logique


    //valeurs humaines
    {
        step: 111,
        type: 'informations',
        titre: messages.TITRE,
        titre1: messages.TITRE1,
        contenu: messages.INFO9,
        titre2: messages.TITRE2,
        consignes: [
            {
                consigne: messages.INFOINST9,
            },
        ]
    },
    {
        step: 112,
        inputNumber: 82,
        type: 'pageRadioButton',
        instructions: [
            {
                instruction: messages.VALEURSHUMAINES,
            },
        ],
        value: '',
        key: 'VH1',
        inputs: [
            {
                label: messages.VALEURSHUMAINES1,
                valueKey: 'VAL_POWER',
            },
            {
                label: messages.VALEURSHUMAINES1BIS,
                valueKey: 'VAL_HONOUR',
            },
        ]
    },
    {
        step: 113,
        inputNumber: 83,
        type: 'pageRadioButton',
        instructions: [
            {
                instruction: messages.VALEURSHUMAINES,
            },
        ],
        value: '',
        key: 'VH2',
        inputs: [
            {
                label: messages.VALEURSHUMAINES2,
                //valueKey: 'VAL_SUCCESS',
                valueKey: 'VAL_POWER',
            },
            {
                label: messages.VALEURSHUMAINES2BIS,
                valueKey: 'VAL_MORALITY',
            },
        ]
    },
    {
        step: 114,
        inputNumber: 84,
        type: 'pageRadioButton',
        instructions: [
            {
                instruction: messages.VALEURSHUMAINES,
            },
        ],
        value: '',
        key: 'VH3',
        inputs: [
            {
                label: messages.VALEURSHUMAINES3,
                valueKey: 'VAL_HARMONY',
            },
            {
                label: messages.VALEURSHUMAINES3BIS,
                valueKey: 'VAL_AFFECTION',
            },
        ]
    },
    {
        step: 115,
        inputNumber: 85,
        type: 'pageRadioButton',
        instructions: [
            {
                instruction: messages.VALEURSHUMAINES,
            },
        ],
        value: '',
        key: 'VH4',
        inputs: [
            {
                label: messages.VALEURSHUMAINES4,
                valueKey: 'VAL_MORALITY',
            },
            {
                label: messages.VALEURSHUMAINES4BIS,
                valueKey: 'VAL_POWER',
            },
        ]
    },
    {
        step: 116,
        inputNumber: 86,
        type: 'pageRadioButton',
        instructions: [
            {
                instruction: messages.VALEURSHUMAINES,
            },
        ],
        value: '',
        key: 'VH5',
        inputs: [
            {
                label: messages.VALEURSHUMAINES5,
                //valueKey: 'VAL_SUCCESS',
                valueKey: 'VAL_HARMONY',
            },
            {
                label: messages.VALEURSHUMAINES5BIS,
                valueKey: 'VAL_AFFECTION',
            },
        ]
    },


    {
        step: 117,
        inputNumber: 87,
        type: 'pageRadioButton',
        instructions: [
            {
                instruction: messages.VALEURSHUMAINES,
            },
        ],
        value: '',
        key: 'VH6',
        inputs: [
            {
                label: messages.VALEURSHUMAINES6,
                valueKey: 'VAL_HONOUR',
            },
            {
                label: messages.VALEURSHUMAINES6BIS,
                //valueKey: 'VAL_HARMONY',
                valueKey: 'VAL_POWER',
            },
        ]
    },
    {
        step: 118,
        inputNumber: 88,
        type: 'pageRadioButton',
        instructions: [
            {
                instruction: messages.VALEURSHUMAINES,
            },
        ],
        value: '',
        key: 'VH7',
        inputs: [
            {
                label: messages.VALEURSHUMAINES7,
                valueKey: 'VAL_POWER',
            },
            {
                label: messages.VALEURSHUMAINES7BIS,
                //valueKey: 'VAL_SUCCESS',
                valueKey: 'VAL_HARMONY',
            },
        ]
    },
    {
        step: 119,
        inputNumber: 89,
        type: 'pageRadioButton',
        instructions: [
            {
                instruction: messages.VALEURSHUMAINES,
            },
        ],
        value: '',
        key: 'VH8',
        inputs: [
            {
                label: messages.VALEURSHUMAINES8,
                valueKey: 'VAL_AFFECTION',
            },
            {
                label: messages.VALEURSHUMAINES8BIS,
                valueKey: 'VAL_HONOUR',
            },
        ]
    },
    {
        step: 120,
        inputNumber: 90,
        type: 'pageRadioButton',
        instructions: [
            {
                instruction: messages.VALEURSHUMAINES,
            },
        ],
        value: '',
        key: 'VH9',
        inputs: [
            {
                label: messages.VALEURSHUMAINES9,
                valueKey: 'VAL_HARMONY',
            },
            {
                label: messages.VALEURSHUMAINES9BIS,
                valueKey: 'VAL_MORALITY',
            },
        ]
    },
    {
        step: 121,
        inputNumber: 91,
        type: 'pageRadioButton',
        instructions: [
            {
                instruction: messages.VALEURSHUMAINES,
            },
        ],
        value: '',
        key: 'VH10',
        inputs: [
            {
                label: messages.VALEURSHUMAINES10,
                valueKey: 'VAL_POWER',
            },
            {
                label: messages.VALEURSHUMAINES10BIS,
                valueKey: 'VAL_AFFECTION',
            },
        ]
    },
    {
        step: 122,
        inputNumber: 92,
        type: 'pageRadioButton',
        instructions: [
            {
                instruction: messages.VALEURSHUMAINES,
            },
        ],
        value: '',
        key: 'VH11',
        inputs: [
            {
                label: messages.VALEURSHUMAINES11,
                valueKey: 'VAL_MORALITY',
            },
            {
                label: messages.VALEURSHUMAINES11BIS,
                valueKey: 'VAL_HONOUR',
            },
        ]
    },
    {
        step: 123,
        inputNumber: 93,
        type: 'pageRadioButton',
        instructions: [
            {
                instruction: messages.VALEURSHUMAINES,
            },
        ],
        value: '',
        key: 'VH12',
        inputs: [
            {
                label: messages.VALEURSHUMAINES12,
                //valueKey: 'VAL_SUCCESS',
                valueKey: 'VAL_HARMONY',
            },
            {
                label: messages.VALEURSHUMAINES12BIS,
                //valueKey: 'VAL_HARMONY',
                valueKey: 'VAL_AFFECTION',
            },
        ]
    },
    {
        step: 124,
        inputNumber: 94,
        type: 'pageRadioButton',
        instructions: [
            {
                instruction: messages.VALEURSHUMAINES,
            },
        ],
        value: '',
        key: 'VH13',
        inputs: [
            {
                label: messages.VALEURSHUMAINES13,
                valueKey: 'VAL_AFFECTION',
            },
            {
                label: messages.VALEURSHUMAINES13BIS,
                valueKey: 'VAL_MORALITY',
            },
        ]
    },
    {
        step: 125,
        inputNumber: 95,
        type: 'pageRadioButton',
        instructions: [
            {
                instruction: messages.VALEURSHUMAINES,
            },
        ],
        value: '',
        key: 'VH14',
        inputs: [
            {
                label: messages.VALEURSHUMAINES14,
                valueKey: 'VAL_HARMONY',
            },
            {
                label: messages.VALEURSHUMAINES14BIS,
                valueKey: 'VAL_POWER',
            },
        ]
    },
    {
        step: 126,
        inputNumber: 96,
        type: 'pageRadioButton',
        instructions: [
            {
                instruction: messages.VALEURSHUMAINES,
            },
        ],
        value: '',
        key: 'VH15',
        inputs: [
            {
                label: messages.VALEURSHUMAINES15,
                valueKey: 'VAL_HONOUR',
            },
            {
                label: messages.VALEURSHUMAINES15BIS,
                valueKey: 'VAL_SUCCESS',
            },
        ]
    },
    //fin valeurs humaines

    // informations de bases 
    {
        step: 127,
        type: 'informations',
        titre: messages.TITRE,
        titre1: messages.TITRE1,
        contenu: messages.INFO10,
        titre2: messages.TITRE2,
        consignes: [
            {
                consigne: messages.INFOINST10,
            },
        ]
    },
    {
        step: 128,
        inputNumber: 97,
        type: 'pageRadioButton',
        instructions: [
            {
                instruction: messages.INFOPERSO1,
            },
        ],
        value: '',
        key: 'SEXE',
        inputs: [
            {
                label: messages.INFOPERSO1A,
                valueKey: 'MALE',
            },
            {
                label: messages.INFOPERSO1B,
                valueKey: 'FEMALE',
            },
        ]
    },
    {
        step: 129,
        inputNumber: 98,
        type: 'pageRadioButton',
        instructions: [
            {
                instruction: messages.INFOPERSO2,
            },
        ],
        value: '',
        key: 'AGE',
        inputs: [
            {
                label: messages.INFOPERSO2A,
                valueKey: 'AGE1',
            },
            {
                label: messages.INFOPERSO2B,
                valueKey: 'AGE2',
            },
            {
                label: messages.INFOPERSO2C,
                valueKey: 'AGE3',
            },
            {
                label: messages.INFOPERSO2D,
                valueKey: 'AGE4',
            },
            {
                label: messages.INFOPERSO2E,
                valueKey: 'AGE5',
            },
            {
                label: messages.INFOPERSO2F,
                valueKey: 'AGE6',
            },
        ]
    },

    {
        step: 130,
        inputNumber: 99,
        type: 'pageRadioButton',
        instructions: [
            {
                instruction: messages.INFOPERSO3,
            },
        ],
        value: '',
        key: 'ECOLE',
        inputs: [
            {
                label: messages.INFOPERSO3A,
                valueKey: 'ECOLE1',
            },
            {
                label: messages.INFOPERSO3B,
                valueKey: 'ECOLE2',
            },
            {
                label: messages.INFOPERSO3C,
                valueKey: 'ECOLE3',
            },
        ]
    },
    {
        step: 131,
        inputNumber: 100,
        type: 'pageRadioButton',
        instructions: [
            {
                instruction: messages.INFOPERSO4,
            },
        ],
        value: '',
        key: 'CONTINENT',
        inputs: [
            {
                label: messages.INFOPERSO4A,
                valueKey: 'CONTINENT1',
            },
            {
                label: messages.INFOPERSO4C,
                valueKey: 'CONTINENT3',
            },
            {
                label: messages.INFOPERSO4D,
                valueKey: 'CONTINENT4',
            },
            {
                label: messages.INFOPERSO4E,
                valueKey: 'CONTINENT5',
            },
            {
                label: messages.INFOPERSO4F,
                valueKey: 'CONTINENT6',
            },
            {
                label: messages.INFOPERSO4G,
                valueKey: 'CONTINENT7',
            },
            {
                label: messages.INFOPERSO4H,
                valueKey: 'CONTINENT8',
            },
        ]
    },
    {
        step: 132,
        inputNumber: 101,
        type: 'pageRadioButton',
        instructions: [
            {
                instruction: messages.INFOPERSO5,
            },
        ],
        value: '',
        key: 'POSTE',
        inputs: [
            {
                label: messages.INFOPERSO5A,
                valueKey: 'POSTE1',
            },
            {
                label: messages.INFOPERSO5B,
                valueKey: 'POSTE2',
            },
            {
                label: messages.INFOPERSO5C,
                valueKey: 'POSTE3',
            },
            {
                label: messages.INFOPERSO5D,
                valueKey: 'POSTE4',
            },
            {
                label: messages.INFOPERSO5E,
                valueKey: 'POSTE5',
            },
        ]
    },
    {
        step: 133,
        type: 'results',
        title: messages.TITRE,
        accueils: {
            accueil1: messages.ACCUEIL5_INFO4,
            accueil2: messages.ACCUEIL5_INFO5,
            accueil3: messages.ACCUEIL5_INFO6,
            accueil4: messages.ACCUEIL5_INFO7,
        }
    }
]